import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { getRequest } from '../../../../helpers/apiHandler';
import { showAlert } from '../../../../store/actions/alertAction';

const WhatsAppNumberDropdown = ({ isLoggedIn, onPhoneNumberSelect }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const onPhoneNumberSelectRef = useRef(onPhoneNumberSelect);

  // Update the ref when the callback changes
  useEffect(() => {
    onPhoneNumberSelectRef.current = onPhoneNumberSelect;
  }, [onPhoneNumberSelect]);

  useEffect(() => {
    let isMounted = true;

    if (isLoggedIn) {
      const requestData = { headers: { Authorization: access_token.token } };
      getRequest('/v2/whatsapp/get-shared-business', requestData, (res) => {
        if (!isMounted) return;

        if (res.success) {
          const wabaData = res.data.data;
          if (wabaData.length > 0) {
            const defaultWabaId = wabaData[0].target_ids[0];
            setSelectedWabaId(defaultWabaId);
            // Now let's fetch phone numbers
            getRequest(
              `/v2/whatsapp/get-phone-numbers?waba_id=${defaultWabaId}`,
              requestData,
              (res) => {
                if (!isMounted) return;

                if (res.success) {
                  const phoneNumbersResponse = res.data.data;
                  const formattedPhoneNumbers = phoneNumbersResponse.data.map((number) => ({
                    value: number.id,
                    label: `${number.verified_name} - ${number.display_phone_number}`,
                    wabaId: defaultWabaId,
                  }));
                  setPhoneNumbers(formattedPhoneNumbers);

                  // Auto-select the first phone number if available
                  if (formattedPhoneNumbers.length > 0 && onPhoneNumberSelectRef.current) {
                    onPhoneNumberSelectRef.current({
                      phoneId: formattedPhoneNumbers[0].value,
                      wabaId: defaultWabaId,
                    });
                  }

                  dispatch(
                    showAlert(
                      'Integration Successful. Your WhatsApp Business Platform (API) has been successfully Integrated through Facebook',
                      'success'
                    )
                  );
                } else {
                  setPhoneNumbers([]);
                  dispatch(showAlert('Integration Failed. Please retry again', 'danger'));
                }
              }
            );
          }
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [isLoggedIn, access_token.token, dispatch]); // Removed onPhoneNumberSelect from dependencies

  return (
    <>
      <p>Choose the phone number to be connected.</p>
      <Select
        options={phoneNumbers}
        defaultValue={phoneNumbers.length > 0 ? phoneNumbers[0] : null}
        onChange={(selectedOption) => {
          if (selectedOption && onPhoneNumberSelectRef.current) {
            onPhoneNumberSelectRef.current({
              phoneId: selectedOption.value,
              wabaId: selectedWabaId,
            });
          }
        }}
      />
    </>
  );
};

export default WhatsAppNumberDropdown;
